import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faArrowCircleUp,
} from "@fortawesome/free-solid-svg-icons";

const SubscriptionHistory = ({transactions}) => {
    return ( <div>
        <h3 className="text-xl font-bold mb-4 text-yellow-600">
          Transaction History
        </h3>
          <div className="space-y-4">
            {transactions.map((txn, idx) => (
              <div
                key={txn.reference + idx}
                className="bg-gray-100 p-4 rounded-lg shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-gray-800">
                      {txn.description}
                    </p>
                    <p className="text-sm text-gray-500">
                      Plan:{" "}
                      <span className="text-gray-700">{txn.plan?.name}</span>
                    </p>
                    <p className="text-sm text-gray-500">
                      Quantity:{" "}
                      <span className="text-gray-700">{txn.quantity}</span>
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      <FontAwesomeIcon
                        icon={faCalendar}
                        className="mr-2 text-gray-500"
                      />
                      {txn.createdAt.split("T")[0]}
                    </p>
                  </div>
                  <div className="flex items-center">
                    <FontAwesomeIcon
                      icon={faArrowCircleUp}
                      className="text-green-500 mr-2"
                    />
                    <span className="text-gray-800 font-semibold">
                      ₦{txn.amount.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {transactions.length === 0 && (
              <p className="text-center text-gray-500">
                No transactions found.
              </p>
            )}
          </div>
      </div> );
}
 
export default SubscriptionHistory;